import { gsap } from 'gsap'

import { scrollLock } from './utils'

import InitAccesibility from './nav-accessibility'

let headerEl = document.getElementById('nav-wrapper')

let setActiveMenu = (el, currentMenu) => {
  el.props.activeMenu = currentMenu
}

let headerClickToClose = (e) => {
  document.querySelectorAll('.nav').forEach((nav) => {
    if (nav.classList.contains('nav--open')) {
      closeMenu(nav)
    }
  })
}

const resetSecondaryMenu = (el) => {
  el.classList.remove('nav--secondary-menu-open')

  let contentContainer

  if (el.classList.contains('nav--mobile')) {
    contentContainer = el.querySelector('.nav--mobile__inner-container')
  } else {
    contentContainer = el.querySelector('.nav__secondary-menu')
  }

  // remove active element class on mobile
  if (window.matchMedia('(max-width: 640px)').matches) {
    if (el.querySelector('.nav__main-menu-link--active')) {
      el.querySelector('.nav__main-menu-link--active').classList.remove(
        'nav__main-menu-link--active'
      )
    }

    el.querySelectorAll('.nav__secondary-menu__item--animate-in').forEach(
      (item) => {
        item.classList.remove('nav__secondary-menu__item--animate-in')

        window.setTimeout(() => {
          item.classList.remove('nav__secondary-menu__item--visible')

          window.requestAnimationFrame(() => {
            gsap.to(contentContainer, {
              height: 'auto',
              duration: 0.3,
            })
          })
        }, 300)
      }
    )
  }
}

const calculateTipOffset = () => {
  let megamenuOpener = document.querySelector('.megamenu-opener.active'),
    megamenuEl = document.querySelector('.nav.nav--open')

  let triangleTip = megamenuEl.querySelector('.nav__tip')

  if (triangleTip) {
    let offset =
      megamenuOpener.offsetLeft +
      megamenuOpener.closest('.container').offsetLeft +
      megamenuOpener.offsetWidth / 2

    megamenuEl.querySelector('.nav__tip').style.left = offset + 'px'
  }
}

const closeMenu = (el) => {
  scrollLock(false)
  resetSecondaryMenu(el)
  InitAccesibility(el, false)
  setActiveMenu(el, 0)
  headerEl.removeEventListener('click', headerClickToClose)

  headerEl.removeAttribute('style')
  headerEl.props.navMargin = 0
  headerEl.props.submenuOpen = false
  // el.props.submenuActive = false;

  el.classList.remove(
    'nav--open',
    'nav--secondary-menu-open',
    'animation-delay'
  )

  document.querySelector('.overlay').classList.remove('overlay--visible')

  document
    .querySelectorAll('.megamenu-opener, .menu-trigger')
    .forEach((menuOpener) => {
      menuOpener.classList.remove('active')
    })

  window.removeEventListener('resize', calculateTipOffset)
}

const openMenu = (megamenuEl, menuOpener) => {
  // removing active clases from all burgers but the one we just clicked
  document.querySelectorAll('.megamenu-opener, .menu-trigger').forEach((el) => {
    if (menuOpener !== el) {
      el.classList.remove('active')
    } else {
      menuOpener.classList.add('active')
    }
  })

  // check if other navs are open and add delay if so
  document.querySelectorAll('.nav').forEach((nav) => {
    if (nav !== megamenuEl) {
      if (nav.classList.contains('nav--open')) {
        nav.classList.remove('nav--open', 'animation-delay')
        megamenuEl.classList.add('animation-delay')
      }
    }

    nav.querySelectorAll('img').forEach((image) => {
      image.src = image.dataset.src
    })
  })

  // submenuOpen = true;

  headerEl.props.submenuOpen = true
  headerEl.style.transition = '0.3s'
  headerEl.style.marginTop = 0

  megamenuEl.classList.add('nav--open')
  document.querySelector('.overlay').classList.add('overlay--visible')

  calculateTipOffset()

  window.addEventListener('resize', calculateTipOffset)

  if (!megamenuEl.classList.contains('nav--mobile')) {
    InitAccesibility(megamenuEl, true)
  }

  // add header click listener
  //headerEl.addEventListener('click', headerClickToClose);
}

const toggleAccordion = (open, el) => {
  if (open) {
    el.classList.add('nav__mobile-dropdown-wrapper--open')
  } else {
    el.classList.remove('nav__mobile-dropdown-wrapper--open')
  }
}

const mobileAccordions = (el) => {
  el.querySelectorAll('.nav__mobile-dropdown-wrapper').forEach(
    (mobileDropdownWrapper) => {
      let accordionOpener = mobileDropdownWrapper.querySelector(
        '.nav__mobile-accordion-opener'
      )

      accordionOpener.addEventListener('click', () => {
        // close all the others but this

        el.querySelectorAll('.nav__mobile-dropdown-wrapper').forEach((item) => {
          if (item !== mobileDropdownWrapper) {
            resetSecondaryMenu(el)
            item.classList.remove('nav__mobile-dropdown-wrapper--open')
          }
        })

        if (
          mobileDropdownWrapper.classList.contains(
            'nav__mobile-dropdown-wrapper--open'
          )
        ) {
          toggleAccordion(false, mobileDropdownWrapper)
          resetSecondaryMenu(el)
        } else {
          toggleAccordion(true, mobileDropdownWrapper)
        }
      })
    }
  )
}

const switchContent = (button, el) => {
  let contentContainer

  if (el.classList.contains('nav--mobile')) {
    contentContainer = el.querySelector('.nav--mobile__inner-container')

    gsap.to(el.querySelector('.container'), {
      scrollTop: 0,
      duration: 0.3,
    })
  } else {
    contentContainer = el.querySelector('.nav__secondary-menu')
  }

  if (button.classList.contains('nav__main-menu-link--active')) {
    return
  }

  el.querySelectorAll('.nav__main-menu-link').forEach((item, index) => {
    if (item === button) {
      setActiveMenu(el, index)
    }
  })

  let targetMenu = button.getAttribute('data-targetmenu')

  // let nextContent = document.getElementById(targetMenu);
  // we should rework it so it doesn't have id's (now it duplicates with mobile nav)
  let nextContent = el.querySelector(`#${targetMenu}`)

  el.querySelectorAll('.nav__main-menu-link').forEach((button) => {
    button.classList.remove('nav__main-menu-link--active')
    button.setAttribute('aria-expanded', false)
  })

  button.classList.add('nav__main-menu-link--active')
  button.setAttribute('aria-expanded', true)

  // animations should start here

  el.querySelectorAll('.nav__secondary-menu__item').forEach((item) => {
    item.classList.remove('nav__secondary-menu__item--animate-in')
  })

  nextContent.classList.add('nav__secondary-menu__item--visible')

  el.classList.add('nav--animating')

  let setHeight = () => {
    let height = nextContent.offsetHeight

    if (height < el.querySelector('.nav__main-menu').offsetHeight) {
      height = el.querySelector('.nav__main-menu').offsetHeight
    }

    return height
  }

  gsap.to(contentContainer, {
    height: setHeight(),
    duration: 0.3,
    onComplete: () => {
      el.querySelectorAll('.nav__secondary-menu__item').forEach((item) => {
        if (item !== nextContent) {
          item.classList.remove(
            'nav__secondary-menu__item--animate-in',
            'nav__secondary-menu__item--visible'
          )
          item.setAttribute('aria-hidden', 'true')
        } else {
          item.classList.add('nav__secondary-menu__item--visible')
          item.setAttribute('aria-hidden', 'false')
          requestAnimationFrame(() => {
            item.classList.add('nav__secondary-menu__item--animate-in')
            el.classList.remove('nav--animating')
          })
        }
      })
    },
  })
}

const navScroll = (headerEl) => {
  if (window.matchMedia('(min-width: 640px)').matches) {
    let scrollDiff = window.scrollY - headerEl.props.lastScroll
    const spacer = document.getElementById('header-spacer')

    headerEl.props.navMargin += scrollDiff

    headerEl.props.navMargin >= headerEl.offsetHeight
      ? headerEl.classList.remove('header-visible')
      : headerEl.classList.add('header-visible')

    if (!headerEl.props.submenuOpen) {
      headerEl.props.navMargin = Math.max(
        0,
        Math.min(headerEl.props.navMargin, headerEl.offsetHeight)
      )
    } else {
      headerEl.props.navMargin = 0
    }

    if (!headerEl.submenuOpen) {
      headerEl.style.marginTop = -headerEl.props.navMargin + 'px'
    }

    // sticky subheader

    const stickySubheader = document.querySelector('.sticky')
    const stickyFilters = document.querySelector('#main-collection-filters')
    const anchorLink = document.querySelector('.anchor-links');

    if (stickySubheader) {
      if (stickySubheader.getBoundingClientRect().y === 0) {
        headerEl.props.transformAmount =
          -headerEl.props.navMargin + headerEl.offsetHeight
        headerEl.classList.add('sticky-active')

        stickySubheader.style.marginTop = -headerEl.props.transformAmount + 'px'
        stickySubheader.style.paddingTop = headerEl.props.transformAmount + 'px'

        stickySubheader.classList.add('sticky--stuck')

        if (stickyFilters) {
          stickyFilters.style.marginTop = headerEl.props.transformAmount + 'px'
        }
      } else {
        stickySubheader.classList.remove('sticky--stuck')
        headerEl.classList.remove('sticky-active')
        if (stickyFilters) {
          stickyFilters.style.marginTop = 0
        }
      }
    }

    if(anchorLink) {}

    headerEl.props.lastScroll = Math.max(
      0,
      Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight)
    )

    // add class if at top

    if (headerEl.props.lastScroll === 0) {
      headerEl.classList.add('reached-top')
      spacer.style.paddingTop = 0
    } else {
      headerEl.classList.remove('reached-top')
      spacer.style.paddingTop = headerEl.offsetHeight + 'px'
    }
  }
}

// close search
const resultsContainer = document.getElementById('predictive-search')
const searchOverlay = document.querySelector('.search-overlay')

const closeSearch = () => {
  searchOverlay.classList.remove('open')
  document.body.classList.remove('active', 'search')

  document
    .querySelectorAll('.predictive-search')
    .forEach((resultsContainer) => {
      resultsContainer.classList.remove('open')
    })
}

export {
  mobileAccordions,
  resetSecondaryMenu,
  openMenu,
  closeMenu,
  navScroll,
  switchContent,
  setActiveMenu,
  closeSearch,
}
